module.exports = __webpack_public_path__ + "assets/img/hall.83ede518.png";